import { FormControlLabel, Typography } from "@mui/material";
import React from "react";
import { UseAppDispatch } from "redux/store";
import { useSelector } from "react-redux";

import {
  changeTravellerTypes,
  filterSelector,
  ITravellerTypes,
} from "redux/filters";

import { useTranslations } from "hooks/useTranslations";
import { ITravellerTypesFilter } from "hooks/translations.interfaces";
import { Box, Checkbox, SxProps } from "@mui/material";
import { deepCloneObject, pushToDataLayer } from "@thekilroygroup/shared-ui";

export default function TravellerTypesFilter() {
  const dispatch = UseAppDispatch();
  const { travellerTypes } = useSelector(filterSelector);
  const { translations } = useTranslations();

  const translationsFilter: ITravellerTypesFilter = deepCloneObject(
    translations.filters.filterTypes.filter((obj) => {
      return obj.filter === "travellerTypes";
    })[0],
  );

  const checkForTouched = (nextTravellerTypes: ITravellerTypes) => {
    if (
      nextTravellerTypes.ordinary === true &&
      nextTravellerTypes.studentsAndYouth === true
    ) {
      return false;
    }
    return true;
  };

  const handleChangeOrdinary = (
    element: React.ChangeEvent<HTMLInputElement>,
    value: boolean,
  ) => {
    const nextTravellerTypes: ITravellerTypes = deepCloneObject(travellerTypes);
    nextTravellerTypes.ordinary = value;
    nextTravellerTypes.touched = checkForTouched(nextTravellerTypes);
    pushToDataLayer(`Ordinary ${value}`, "Filter - Traveller types");
    dispatch(changeTravellerTypes(nextTravellerTypes));
  };

  const handleChangeStudentsAndYouth = (
    element: React.ChangeEvent<HTMLInputElement>,
    value: boolean,
  ) => {
    const nextTravellerTypes: ITravellerTypes = deepCloneObject(travellerTypes);
    nextTravellerTypes.studentsAndYouth = value;
    nextTravellerTypes.touched = checkForTouched(nextTravellerTypes);
    pushToDataLayer(`Students and youth ${value}`, "Filter - Traveller types");
    dispatch(changeTravellerTypes(nextTravellerTypes));
  };

  return (
    <>
      <Box sx={sxStyles.checkbox}>
        <FormControlLabel
          control={
            <Checkbox
              onChange={handleChangeOrdinary}
              checked={travellerTypes.ordinary}
            />
          }
          label={
            <>
              <Box sx={sxStyles.labelText}>
                <Typography variant="titleMedium" weight="bold">
                  {translationsFilter.ordinaryTickets.label}
                </Typography>
              </Box>
              <Typography variant="bodySmall">
                {translationsFilter.ordinaryTickets.note}
              </Typography>
            </>
          }
          sx={sxStyles.label}
        />
      </Box>
      <Box sx={sxStyles.checkbox}>
        <FormControlLabel
          control={
            <Checkbox
              onChange={handleChangeStudentsAndYouth}
              checked={travellerTypes.studentsAndYouth}
            />
          }
          label={
            <>
              <Box sx={sxStyles.labelText}>
                <Typography variant="titleMedium" weight="bold">
                  {translationsFilter.studentAndYouthTickets.label}
                </Typography>
              </Box>
              <Typography variant="bodySmall">
                {translationsFilter.studentAndYouthTickets.note}
              </Typography>
            </>
          }
          sx={sxStyles.label}
        />
      </Box>
    </>
  );
}

const sxStyles: { [key: string]: SxProps } = {
  checkbox: {
    borderBottom: "1px solid",
    borderBottomColor: "grey.200",
    "&:last-of-type": {
      borderBottom: "0px solid",
    },
  },
  label: {
    mt: 1,
    mb: 1,
  },
};
